module.exports = __webpack_public_path__ + "img/SketchPng6e804c5659e9f896c39d80de17443e6b8790f05496f6993a5135d68d56e67707.f1fb6a23.png";